import { ExternalLink } from "lucide-react";
import { SlideHeader, Headline, FOUNDER_IMG } from "../shared";

export function Slide13Team() {
  const PEOPLE = [
    {
      name: "Greg Demirjian",
      role: "Founder, CEO & Inventor",
      photo: FOUNDER_IMG,
      bio: "Took the patented product from concept through manufacturing, launch and Shark Tank.",
    },
    {
      name: "The Faction",
      people: "Matt Murphy & Beth Wilson",
      role: "App & Sensor Development",
      bio: "Lead the companion app and sensor work.",
      href: "https://mattmurphy.ai/community/",
    },
    {
      name: "Neo IP",
      role: "Patent Counsel",
      bio: "Supports portfolio strategy and continuation filings.",
      href: "https://neoipassets.com/",
    },
    {
      name: "Momentum",
      role: "Sensor Integration Partner (exploring)",
      bio: "Open Wearables unifies data from Garmin, Oura, Whoop, Apple Health and other sensors into one API, a potential bridge between third-party wearables and WearSpray IQ.",
      href: "https://themomentum.ai/",
    },
    {
      name: "Clinical Advisor",
      role: "Dermatology Partner (exploring)",
      bio: "An open advisory seat for a dermatologist or medical aesthetics physician to guide the Clinical & Adherence program.",
      placeholder: true,
    },
  ];
  return (
    <div className="max-w-6xl" data-testid="pitch-slide-team">
      <SlideHeader n="14" label="Team" />
      <Headline>
        The people behind <span className="text-accent">the product.</span>
      </Headline>
      <div className="grid sm:grid-cols-3 lg:grid-cols-5 gap-4 mt-6">
        {PEOPLE.map((p) => (
          <div
            key={p.name}
            className={`rounded-xl p-3.5 ${p.placeholder ? "border border-dashed border-zinc-700 bg-transparent" : "border border-zinc-800 bg-white/[0.02]"}`}
            data-testid={`pitch-team-card-${p.name.toLowerCase().replace(/\s+/g, "-")}`}
          >
            {p.photo ? (
              <img src={p.photo} alt={p.name} className="w-11 h-11 rounded-full object-cover border border-zinc-700" />
            ) : (
              <div className={`w-11 h-11 rounded-full border flex items-center justify-center font-heading text-base ${p.placeholder ? "border-dashed border-zinc-600 text-zinc-500" : "border-zinc-700 text-accent"}`}>
                {p.placeholder ? "+" : p.name.charAt(0)}
              </div>
            )}
            <p className={`font-heading text-sm font-medium mt-2.5 ${p.placeholder ? "text-zinc-400" : "text-white"}`}>{p.name}</p>
            {p.people && <p className="font-body text-zinc-400 text-xs mt-0.5">{p.people}</p>}
            <p className={`font-mono text-[10px] tracking-[0.15em] uppercase mt-1 ${p.placeholder ? "text-zinc-500" : "text-accent"}`}>{p.role}</p>
            <p className="font-body text-zinc-400 text-xs leading-snug mt-1.5">{p.bio}</p>
            {p.href && (
              <a href={p.href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 font-body text-xs text-accent hover:underline mt-1">
                Learn more <ExternalLink size={11} />
              </a>
            )}
            {p.placeholder && (
              <span className="inline-flex items-center gap-1.5 font-mono text-[9px] tracking-[0.15em] uppercase text-zinc-500 mt-1">
                <span className="w-1 h-1 rounded-full bg-zinc-500" /> Open seat
              </span>
            )}
          </div>
        ))}
      </div>
      <p className="font-mono text-[10px] tracking-[0.15em] uppercase text-zinc-500 mt-3">
        Hiring with the seed round: Head of Hardware Engineering, full time.
      </p>
    </div>
  );
}
